import React from 'react';
import Spinner from 'components/loader/Spinner';
import useTablePreview from '../hooks/usePreviewTable';
import { NTable } from '@innersource-nn/novoui-react';

const TablePreview = () => {
    const { tableHeaders, rows, loading, error } = useTablePreview();

    return (
        <div>
            {loading ? (
                <Spinner />
            ) : (
                !error && (
                    <NTable
                        headers={tableHeaders}
                        columnBorder={true}
                        items={rows}
                    />
                )
            )}
        </div>
    );
};

export default TablePreview;
